/* eslint-disable */
import React, { useRef, useState, useEffect } from "react";
import { useAppSelector } from "hooks/reduxHooks";
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Divider,
  LinearProgress,
  Grid,
  Chip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import { enqueueSnackbar } from "notistack";
import { useHistory } from "react-router-dom";
import {
  getCoachTeams,
  createNewTeam,
  deleteTeam,
  updateTeam,
} from "../../repositories/teamsApi";
import { FloatingMenu } from "components/FloatingMenu/FloatingMenu";
import { selectCurrentClinician } from "../../store/ClinicianStore/selectors";
import CheckBox from "@mui/material/Checkbox";
import { Checkbox } from "components/Checkbox/Checkbox";
const TeamSelector: React.FC<any> = ({
  selectable,
  selectedTeams = [],
  setSelectedTeams = () => {},
  customWidth,
}: {
  selectable?: boolean;
  customWidth?: string;
  selectedTeams: any[];
  setSelectedTeams: any;
}) => {
  const [inputValue, setInputValue] = useState({ value: "", editedValue: "" });
  const [teams, setTeams] = useState<any[]>([]);
  const [currentTeam, setCurrentTeam] = useState({ name: "", _id: "" });
  const [isOnMenu, setIsOnMenu] = useState(false);
  const [isOnFloatingMenu, setIsOnFloatingMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const currentClinician = useAppSelector(selectCurrentClinician);
  const timeoutRef = React.useRef<NodeJS.Timeout | undefined>();
  const menuRef = React.useRef<any>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !isOnFloatingMenu &&
        selectable
      ) {
        setOpenMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOnFloatingMenu]);

  const getTeams = async (search?: string, overrideValidations?: boolean) => {
    if (!currentClinician || (currentTeam.name && !overrideValidations)) return;
    setLoading(true);
    try {
      const teams = await getCoachTeams(currentClinician._id, search);
      setTeams(teams);
    } catch (error) {
      setTeams([]);
    }
    setLoading(false);
  };

  const onTypeFinished = (searchingFor: string) => {
    clearTimeout(Number(timeoutRef.current));
    timeoutRef.current = setTimeout(() => getTeams(searchingFor), 500);
  };

  const checkTypeStatus = (value: string) => {
    if (value.length > 2 && value.length != 0) {
      onTypeFinished(value);
    } else if (value.length == 0) {
      onTypeFinished("");
    }
  };

  useEffect(() => {
    getTeams();
  }, []);
  return (
    <Box
      sx={{
        width: customWidth || "80%",
        mt: 1,
        overflow: "scroll",
        height: "500px",
      }}
    >
      <Box sx={{ display: "flex", position: "relative" }}>
        <TextField
          sx={{ borderRadius: "20px" }}
          onKeyDown={async (e) => {
            if (loading) {
              return;
            }
            const isSubmit = e.key === "Enter";
            const isNotLoadingAndHasntTeam = !loading && !teams.length;
            const hasValueAndIsNotEditing =
              inputValue.value && !currentTeam.name;
            if (
              isNotLoadingAndHasntTeam &&
              isSubmit &&
              hasValueAndIsNotEditing &&
              currentClinician
            ) {
              try {
                setLoading(true);
                const newTeam = await createNewTeam(
                  currentClinician._id,
                  inputValue.value
                );

                setTeams([newTeam]);
                enqueueSnackbar("Team created !", { variant: "success" });
              } catch (error) {}
              setLoading(false);
            }
          }}
          size="small"
          variant="filled"
          fullWidth
          onClick={() => {
            setOpenMenu(true);
          }}
          onBlur={() => {
            if (!isOnMenu) {
              setOpenMenu(false);
            }
          }}
          onChange={(e: any) => {
            if (e.target.value.includes(",")) {
              return;
            }
            setInputValue(
              currentTeam.name
                ? { ...inputValue, editedValue: e.target.value }
                : { ...inputValue, value: e.target.value }
            );
            checkTypeStatus(e.target.value);
          }}
          type="text"
          value={currentTeam.name ? inputValue.editedValue : inputValue.value}
          label={
            currentTeam.name
              ? "Edit team name"
              : selectable
              ? "Select a team"
              : "Search or create a new team"
          }
        />
        {currentTeam.name && (
          <IconButton sx={{ mr: 2 }}>
            <SaveIcon
              onClick={async () => {
                if (loading) {
                  return;
                }
                setLoading(true);

                try {
                  await updateTeam(currentTeam._id, inputValue.editedValue);
                  setCurrentTeam({ name: "", _id: "" });
                  setInputValue({
                    editedValue: "",
                    value: "",
                  });
                  enqueueSnackbar("Team updated successfully", {
                    variant: "success",
                  });

                  getTeams("", true);
                } catch (error) {
                  enqueueSnackbar("Error updating team", { variant: "error" });
                }
                setLoading(false);
              }}
            />
          </IconButton>
        )}

        {!currentTeam.name && (
          <IconButton
            sx={{ mr: 2, position: "absolute", right: "10px", bottom: "10px" }}
            style={{ position: "absolute", right: "10px", bottom: "10px" }}
          >
            <ClearIcon
              onClick={() => {
                setCurrentTeam({ name: "", _id: "" });
                setInputValue({
                  ...inputValue,
                  value: "",
                });
                getTeams();
              }}
            />
          </IconButton>
        )}
      </Box>

      {loading && <LinearProgress />}
      {openMenu && (
        <Box
          id="menu-opened"
          ref={menuRef}
          onMouseEnter={() => {
            setIsOnMenu(true);
          }}
          onMouseLeave={() => {
            setIsOnMenu(false);
          }}
          sx={{
            boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
            padding: "15px",
            height: "400px",
            overflowY: "scroll",
          }}
        >
          <Divider sx={{ mb: 2, mt: 2 }} />
          {currentTeam.name && (
            <Typography>
              Edit the name of the team: {currentTeam.name} and click save
              button, or click the X to cancel
            </Typography>
          )}
          {!teams.length && !loading && (
            <Box
              sx={{
                borderBottom: "1px solid grey",
                display: "flex",
                justifyContent: "space-between",
                padding: "5px",
                cursor: "pointer",
                "&:hover": {
                  background: "#f0f0f0",
                },
              }}
            >
              {!currentTeam.name && (
                <Typography>
                  You haven't added any teams yet. Add a team by entering the
                  team name in the input field and clicking 'Enter' to save the
                  team.
                </Typography>
              )}
            </Box>
          )}

          {teams.length > 0 && (
            <Typography sx={{ mr: 2 }} variant="caption">
              (M = Men's, W = Women's)
            </Typography>
          )}

          {teams.map((team: any) => {
            if (loading || currentTeam.name) return <></>;
            return (
              <Box
                key={team._id}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "15px",
                  alignItems: "center",
                  cursor: "pointer",
                  "&:hover": {
                    background: "#f0f0f0",
                  },
                }}
              >
                {selectable && (
                  <CheckBox
                    checked={selectedTeams
                      .map((team: any) => team.name)
                      .includes(team.name)}
                    onChange={() => {
                      if (
                        selectedTeams
                          .map((team: any) => team.name)
                          .includes(team.name)
                      ) {
                        setSelectedTeams(
                          selectedTeams.filter((t: any) => t.name !== team.name)
                        );
                      } else {
                        setSelectedTeams([...selectedTeams, team]);
                      }
                    }}
                  />
                )}
                <Typography
                  sx={{
                    maxWidth: "250px",
                    width: "250px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {team.name}
                </Typography>
                <FloatingMenu
                  isOnMenu={isOnFloatingMenu}
                  setIsOnMenu={setIsOnFloatingMenu}
                  options={[
                    {
                      disabled: selectable,
                      text: "Edit",
                      handler: () => {
                        setCurrentTeam(team);
                        setInputValue({
                          ...inputValue,
                          editedValue: team.name,
                        });
                      },
                    },
                    {
                      disabled: selectable,
                      text: "Delete",
                      handler: async () => {
                        if (loading) return;
                        try {
                          setLoading(true);
                          await deleteTeam(team._id);
                          enqueueSnackbar("Team deleted successfully", {
                            variant: "success",
                          });
                          getTeams();
                        } catch (error) {
                          enqueueSnackbar("Error deleting team", {
                            variant: "error",
                          });
                        }
                        setLoading(false);
                      },
                    },
                  ]}
                  setIsEditButtonDarkMode={setOpenMenu}
                  style={{}}
                  customOptionWidth={"10ch"}
                  loading={false}
                />
              </Box>
            );
          })}
        </Box>
      )}
      {selectedTeams.length > 0 && (
        <>
          {selectedTeams.map((team) => (
            <Grid item justifyContent="space-between">
              <Chip
                key={team.name}
                style={{
                  backgroundColor: "#161728",
                  borderRadius: 10,
                  margin: 3,
                  color: "#FFFFFF",
                }}
                deleteIcon={
                  <CloseIcon
                    style={{
                      color: "white",
                      fontSize: "1.2em",
                      stroke: "white",
                      strokeWidth: 2,
                    }}
                  />
                }
                label={team.name}
                variant="outlined"
                onDelete={() => {
                  setSelectedTeams(
                    selectedTeams.filter(
                      (selectedTeam: any) => selectedTeam._id !== team._id
                    )
                  );
                }}
              />
            </Grid>
          ))}
        </>
      )}
    </Box>
  );
};

export default TeamSelector;
